import type { HardBreakOptions } from "@tiptap/extension-hard-break";
import type { Node as ProsemirrorNode } from "prosemirror-model";

import HardBreak from "@tiptap/extension-hard-break";

type MarkdownSerializerStateLike = {
  write: (content: string) => void;
  inTable?: boolean;
};

interface HardBreakMarkdownStorage {
  markdown: {
    serialize: (
      state: MarkdownSerializerStateLike,
      node: ProsemirrorNode,
      parent: ProsemirrorNode | null,
      index: number,
    ) => void;
  };
}

/*
 * NOTE (Kevin 2025-09-24): Serialize Shift+Enter as literal <br /> tags so the
 * markdown pipeline can round-trip spacing without creating extra paragraphs.
 */
const HardBreakMarkdown = HardBreak.extend<
  HardBreakOptions,
  HardBreakMarkdownStorage
>({
  addStorage() {
    return {
      markdown: {
        serialize(state, node, parent, index) {
          if (!parent) {
            return;
          }

          const nextSibling =
            index + 1 < parent.childCount ? parent.child(index + 1) : null;
          if (!nextSibling || nextSibling.type !== node.type) {
            state.write("<br />");
          }
        },
      },
    };
  },
});

export default HardBreakMarkdown;
